function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("polygon", {
  points: "28.3,24.9 23,19.6 18.7,23.8 16.6,21.7 23,15.3 28.3,20.7 33.7,15.3 40,21.7 37.9,23.8 33.7,19.6  "
}))))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M36.5,49h-15v-1.5c0-6.7-6.9-13.2-7-13.3c-3.7-3.7-5.7-8.7-5.7-13.9c0-5.2,2-10.1,5.7-13.8c3.7-3.7,8.6-5.7,13.8-5.7 c5.2,0,10.1,2,13.8,5.7c3.7,3.7,5.7,8.6,5.7,13.8c0,5.2-2.1,10.3-5.7,13.9c-0.1,0.1-5.6,5.7-5.6,13.3V49z M24.5,46h9.1 c0.6-8.1,6.1-13.7,6.4-13.9c3.1-3.1,4.8-7.4,4.8-11.8c0-4.4-1.7-8.5-4.8-11.7c-3.1-3.1-7.3-4.8-11.7-4.8 c-4.4,0-8.5,1.7-11.7,4.8c-3.1,3.1-4.8,7.3-4.8,11.7c0,4.4,1.8,8.7,4.8,11.7C16.9,32.3,23.6,38.6,24.5,46z"
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 21.6,
  y: 51.8,
  width: 14.8,
  height: 3
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 21.6,
  y: 56.5,
  width: 14.8,
  height: 3
})))));

var SvgLightBulbTwo = function SvgLightBulbTwo(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/light-bulb-two.f1e5cb59.svg";
export { SvgLightBulbTwo as ReactComponent };